import gis from './gis.json'
const code2simple = () => {
  if (window.code2simple) {
    return window.code2simple
  } else {
    const temp: any = {}
    Object.keys(gis).forEach((key: string) => {
      const item = (gis as any)[key]
      if (item.code) {
        temp[item.code] = item
        temp[item.code].simple = key
      }
    })
    return temp
  }
}
export default code2simple()
